import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "terminal-connections mb-3"
};
var _hoisted_2 = {
  class: "mb-1"
};
var _hoisted_3 = {
  class: "item-name"
};
var _hoisted_4 = {
  key: 0,
  class: "d-flex fl-a-c fl-j-c"
};

var _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner"
}, null, -1);

var _hoisted_6 = [_hoisted_5];
var _hoisted_7 = {
  key: 1,
  class: "d-flex fl-a-c fl-j-c"
};

var _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "connected-terminal"
}, null, -1);

var _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "ml-5"
}, "Connected", -1);

var _hoisted_10 = [_hoisted_8, _hoisted_9];
var _hoisted_11 = {
  key: 2,
  class: "d-flex fl-a-c fl-j-c"
};

var _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "disconnected-terminal"
}, null, -1);

var _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "ml-5"
}, "Not connected", -1);

var _hoisted_14 = [_hoisted_12, _hoisted_13];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("settings-payment-terminals")), 1), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.terminalsConnection, function (t, index) {
    return _openBlock(), _createBlock(_component_el_row, {
      class: "items-row",
      key: index
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_el_col, {
          span: 8,
          class: "d-flex fl-a-c"
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("p", _hoisted_3, _toDisplayString(t.terminalId), 1)];
          }),
          _: 2
        }, 1024), _createVNode(_component_el_col, {
          span: 5,
          class: "d-flex fl-a-c fl-j-c"
        }, {
          default: _withCtx(function () {
            return [t.connection === _ctx.TerminalConnectivity.Loading ? (_openBlock(), _createElementBlock("p", _hoisted_4, _hoisted_6)) : _createCommentVNode("", true), t.connection === _ctx.TerminalConnectivity.Connected ? (_openBlock(), _createElementBlock("p", _hoisted_7, _hoisted_10)) : _createCommentVNode("", true), t.connection === _ctx.TerminalConnectivity.Disconnected ? (_openBlock(), _createElementBlock("p", _hoisted_11, _hoisted_14)) : _createCommentVNode("", true)];
          }),
          _: 2
        }, 1024)];
      }),
      _: 2
    }, 1024);
  }), 128))])]);
}